<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <BaseBlock v-if="titreStructure" :title="titreStructure">
        <v-form v-model="valid" ref="form">
          <BaseAlert :error="error" />
          <v-row>
            <v-col cols="12" md="10" offset="0" offset-md="1">
              <v-text-field
                v-model="structure.libelle"
                label="Libellé *"
                @input="resetApiErrors('libelle')"
                :error-messages="checkApiErrors('libelle')"
                :rules="libelleRules"
              ></v-text-field> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" md="10" offset="0" offset-md="1">
              <v-expansion-panels accordion multiple :value="[0]">
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >Référents pour cette structure</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <Referents
                      :referents="structure.referents"
                      typeReferent="referentsStructure"
                      :parentUnique="true"
                      infoParentUnique="Ce référent, initialement rattaché à une autre structure, sera réaffecté à celle-ci"
                      @addReferent="onAddReferent"
                      @deleteReferent="onDeleteReferent"
                    >
                    </Referents>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" md="6" offset="0" offset-md="3">
              <div class="text-center">
                <v-btn
                  class="mx-2"
                  :disabled="!valid"
                  color="primary"
                  @click="enregistrer"
                  :loading="loadingStructure"
                >
                  <v-icon left>save</v-icon>Enregistrer
                </v-btn>
                <router-link
                  :to="{
                    name: 'gestion-structures',
                  }"
                  tag="v-btn"
                >
                  <v-icon title="Annuler"></v-icon>
                  Annuler</router-link
                >
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiStructureRepository from "@/repositories/ApiStructureRepository";
import Referents from "../components/Referents.vue";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "FormStructure",
  components: { BaseBlock, Referents, BaseAlert },
  extends: BaseForm,
  props: ["idStructure"],

  data() {
    return {
      structure: {
        id: null,
        libelle: "",
        referents: [],
      },
      referent: "",
      libelleRules: [
        (v) =>
          (v && v.length >= 2) ||
          "Le libellé doit contenir au minimum 2 caractères",
      ],
      loadingStructure: false,
      loadingReferent: false,
    };
  },
  computed: {
    titreStructure() {
      return this.idStructure > 0
        ? "Édition de la structure id=" + this.idStructure
        : "Nouvelle structure";
    },
  },
  async created() {
    if (this.idStructure > 0) {
      await this.getStructure(this.idStructure);
    }
  },
  methods: {
    async getStructure(id) {
      try {
        const structure = await ApiStructureRepository.getStructure(id);
        this.structure = structure;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async enregistrer() {
      this.loadingStructure = true;
      try {
        if (this.idStructure > 0) {
          await ApiStructureRepository.updateStructure(
            this.idStructure,
            this.structure
          );
          this.$toast.success("Structure modifiée");
        } else {
          await ApiStructureRepository.addStructure(this.structure);
          this.$toast.success("Structure ajoutée");
        }
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loadingStructure = false;
        this.$router.push({ name: "gestion-structures" });
      }
    },
    onAddReferent(currentReferent) {
      this.structure.referents.push(currentReferent);
    },
    onDeleteReferent(currentReferent) {
      this.structure.referents = this.structure.referents.filter(
        (referent) => referent.uid !== currentReferent.uid
      );
    },
  },
};
</script>
